import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Alert from 'ViatoUi/Extranet/Surfaces/Alert';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Headline } from 'ViatoUi/Shared/Typo';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

import Setting from './Setting';

const LinkSettings = () => {
	const { t } = useTranslation('contractGenerator');

	const selectedProduct = useSelector(contractGeneratorSelectors.getSelectedProduct);
	const product = useSelector(contractGeneratorSelectors.getProduct(selectedProduct.id.toString()));
	const selectedOption = selectedProduct.options[product.id] || product.selectedOption;
	const productOption = product.options[selectedOption];

	const extensions = useSelector(contractGeneratorSelectors.getExtensions);
	const selectedExtensions = useSelector(contractGeneratorSelectors.getSelectedExtensions);

	const getExtensionOption = extension => {
		return extension.options[selectedExtensions.options[extension.id] || extension.selectedOption];
	};

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const sessionId = urlParams.get('cgs');

	return (
		<>
			<Headline type='h4'>{t('layouts.share.modals.createLink.linkSettings.title')}</Headline>
			<Spacer height='m' />
			{sessionId ? (
				<>
					<Alert display='inline-block' type='error'>
						{t('layouts.share.modals.createLink.linkSettings.error')}
					</Alert>
					<Spacer height='m' />
					<Button
						type='primary'
						onClick={() => {
							const url = window.location.href;
							const urlWithoutParam = url.split('cgs=')[0].split('#')[0];
							window.location.href = urlWithoutParam;
						}}
					>
						{t('layouts.share.modals.createLink.linkSettings.button')}
					</Button>
					<Spacer height='m' />
				</>
			) : (
				<>
					<Setting
						label={t(`translation:products.${product.key}.title`)}
						option={productOption}
						optionId={parseInt(selectedOption)}
						productId={parseInt(selectedProduct.id)}
						type='products'
					/>
					{selectedExtensions.ids.map(extensionId => (
						<Setting
							key={extensions[extensionId].key}
							label={t(`translation:extensions.${extensions[extensionId].key}.title`)}
							option={getExtensionOption(extensions[extensionId])}
							optionId={parseInt(selectedExtensions.options[extensionId] || extensions[extensionId].selectedOption)}
							productId={parseInt(extensionId)}
							type='extensions'
						/>
					))}
				</>
			)}
		</>
	);
};

export default LinkSettings;
